import identityAccessCaseStudyMd from "../Text/Services/case-study-identity-access-rollout.md";
import kubernetesCaseStudyMd from "../Text/Services/case-study-kubernetes-platform.md";
import spiffeOAuthCaseStudyMd from "../Text/Services/case-study-spiffe-oauth.md";
import keycloakDcrRfc7591Md from "../Text/Services/case-study-keycloak-dcr-rfc7591.md";

export const CASE_STUDIES_BY_SLUG = {
  "identity-access-rollout": {
    title: "Lease Car Company SSO",
    topicLabel: "Identity and Access Management",
    topicAnchor: "topic-identity-access-management",
    markdownUrl: identityAccessCaseStudyMd,
  },
  "spiffe-in-oauth-2-0": {
    title: "SPIFFE identities for OAuth 2.0 clients",
    topicLabel: "Identity and Access Management",
    topicAnchor: "topic-identity-access-management",
    markdownUrl: spiffeOAuthCaseStudyMd,
  },
  "keycloak-dynamic-client-registration-rfc7591": {
    title: "Dynamic Client Registration (RFC 7591) with Keycloak",
    topicLabel: "Identity and Access Management",
    topicAnchor: "topic-identity-access-management",
    markdownUrl: keycloakDcrRfc7591Md,
  },
  "kubernetes-platform-reliability": {
    title: "Multi-cluster SRE and observability",
    topicLabel: "Kubernetes & Cloud Infrastructure",
    topicAnchor: "topic-kubernetes-cloud",
    markdownUrl: kubernetesCaseStudyMd,
  },
};

export const CASE_STUDY_SLUGS = Object.keys(CASE_STUDIES_BY_SLUG);
